//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CardPropertyIcon from './CardPropertyIcon.vue'
import { cardPropertyMixin } from './CardPropertyMixin.js'
import { formatTime, formatDate, transformTableColumnsFromServerFormat, filterData } from '../../components/helpers.js'
import TableCellObject from '../../components/Table/TableCellObject.vue'

export default {
  name: 'CardPropertyTable',
  components: {
    CardPropertyIcon,
    TableCellObject
  },
  mixins: [cardPropertyMixin],
  props: {
    tabProp: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    },
    objectInitial: {
      type: Object,
      default: null
    }
  },
  data: () => {
    return {
      selectFn: null, // @Default
      addFn: null, // @Default

      loading: false,
      hideHeaderLocal: false, // @Default
      hideBottomLocal: false, // @Default
      initialSortFn: null, // @Default
      deleteIconName: 'mdi-delete', // @Default
      deleteButtonTooltipText: 'Удалить', // @Default
      searchColumns: null, // @Default
      searchFieldText: null,
      useServerPagination: false,
      rowsPerPageOptions: undefined,
      pagination: {
        page: 1,
        rowsPerPage: 10,
        rowsNumber: undefined
      }
    }
  },
  computed: {
    columns: function () {
      if (this.tabProp && this.tabProp.tablecolumns) {
        const tablecolumns = this.tabProp.tablecolumns
        const columns = []
        if (Array.isArray(tablecolumns)) { // Кастомное описание колонок
          for (let i = 0; i < tablecolumns.length; i++) {
            columns.push(this.getColumnConfig(tablecolumns[i].name, tablecolumns[i].label, tablecolumns[i].type, null, tablecolumns[i].listvalues, tablecolumns[i].field || null))
          }
        } else if (tablecolumns.name && tablecolumns.name.length) {
          for (let i = 0; i < tablecolumns.name.length; i++) {
            columns.push(this.getColumnConfig(tablecolumns.name[i], tablecolumns.alias[i], tablecolumns.type[i], null, tablecolumns.listvalues && tablecolumns.listvalues[i] || null))
          }
        }
        return columns.length ? columns : null
      }
      return null
    },
    propertyRows: function () {
      let rows = null
      if (this.object && this.tabProp) {
        const propData = this.object[this.tabProp.key]
        rows = transformTableColumnsFromServerFormat(propData)
        if (rows && this.initialSortFn) {
          rows.sort(this.initialSortFn)
        }
      }
      return rows || []
    },
    rows: function () {
      let rows = this.propertyRows
      if (this.searchFieldText && this.searchColumns && this.searchColumns.length) {
        rows = filterData(rows, this.searchFieldText, this.searchColumns)
      }

      return rows
    },
    rowsPerPageCustom: function () {
      const componentProps = this.tabProp.componentProps
      return (componentProps && componentProps.rowsPerPage != null) ? componentProps.rowsPerPage : null
    },
    groupEditDeleteButtonsByColumn: function () {
      const firstGroupedColumn = this.columns.find(column => column.componentProps && column.componentProps.groupByColumn)
      if (firstGroupedColumn) {
        return firstGroupedColumn.field
      } else {
        return null
      }
    },
    mobileDevice: function () {
      return document.body.classList.contains('mobile') || document.body.classList.contains('native-mobile')
    }
  },
  watch: {
    rowsPerPageCustom: {
      handler: function (value) {
        if (value != null) {
          this.pagination.rowsPerPage = value
        }
      },
      immediate: true
    }
  },
  created: function () {
    const componentProps = this.tabProp.componentProps
    if (componentProps) {
      if (componentProps.hideHeader != null) {
        this.hideHeaderLocal = componentProps.hideHeader
      }
      if (componentProps.hideBottom != null) {
        this.hideBottomLocal = componentProps.hideBottom
      }
      if (componentProps.searchColumns != null) {
        this.searchColumns = componentProps.searchColumns
      }
    }
  },
  methods: {
    getColumnConfig: function (name, label, type, componentProps, listvalues, field = null) {
      let columnConfig
      if (arguments.length === 1 && typeof arguments[0] === 'object') {
        columnConfig = arguments[0]
        type = columnConfig.type
        columnConfig.type = undefined
        if (!columnConfig.componentProps) {
          columnConfig.componentProps = {}
        }
        if (!columnConfig.field) {
          columnConfig.field = columnConfig.name
        }
        componentProps = columnConfig.componentProps || {}
      } else {
        columnConfig = {
          name: name,
          label: label,
          field: field || name,
          componentProps: componentProps || {},
          type,
          listvalues
        }
      }

      if (!columnConfig.format && type) {
        if (type === 'datetime') {
          columnConfig.format = function (value) {
            if (value != null && typeof value === 'number') {
              return formatTime(value)
            }
            if (columnConfig.componentProps.noDataText) {
              return value || columnConfig.componentProps.noDataText
            } else {
              return value
            }
          }
        }
        if (type === 'date') {
          columnConfig.format = function (value) {
            if (value != null && typeof value === 'number') {
              return formatDate(value)
            }
            if (columnConfig.componentProps.noDataText) {
              return value || columnConfig.componentProps.noDataText
            } else {
              return value
            }
          }
        }
        if (type === 'array') {
          columnConfig.format = function (value) {
            if (value != null && Array.isArray(value)) {
              return value.join(', ')
            }
            if (columnConfig.componentProps.noDataText) {
              return value || columnConfig.componentProps.noDataText
            } else {
              return value
            }
          }
        }
        if (type === 'boolean') {
          columnConfig.format = function (value) {
            if (value != null && typeof value === 'boolean') {
              return value ? 'Да' : 'Нет'
            }
            return value
          }
        }
        if (type === 'listvalue' && listvalues != null && listvalues.value) {
          columnConfig.format = function (value) {
            const nameIndex = listvalues.value.findIndex(listvalue => listvalue === value)
            if (nameIndex !== -1) {
              return listvalues.name[nameIndex]
            } else if (columnConfig.componentProps.noDataText) {
              return columnConfig.componentProps.noDataText
            }
            return value
          }
        }
        // TODO другие типы
      }

      if (columnConfig.align === undefined) {
        columnConfig.align = 'left'
      }
      if (columnConfig.sortable === undefined) {
        columnConfig.sortable = true
      }

      if (type === '_btn') {
        componentProps.type = type
        componentProps.sortable = false
        componentProps.autoWidth = true
      }
      return columnConfig
    },

    showBtnCell: function (rowIndex, row) {
      if (this.groupEditDeleteButtonsByColumn) {
        const filteredSortedRows = this.$refs.cardPropertyTable && this.$refs.cardPropertyTable.filteredSortedRows

        if (!filteredSortedRows) {
          return false
        }

        return rowIndex === filteredSortedRows.findIndex(r => r[this.groupEditDeleteButtonsByColumn] === row[this.groupEditDeleteButtonsByColumn])
      } else {
        return true
      }
    },

    getCellRowspan: function (key, row) {
      return key
        ? this.rows.filter(r => r[key] === row[key]).length
        : 1
    },

    showGroupedCell: function (key, rowIndex, row) {
      const filteredSortedRows = this.$refs.cardPropertyTable && this.$refs.cardPropertyTable.filteredSortedRows

      if (!filteredSortedRows) {
        return false
      }

      return rowIndex === filteredSortedRows.findIndex(r => r[key] === row[key])
    },

    // @Default
    onRowClick: function (event, record) {
      this.$emit('row-click', {
        record,
        index: this.rows.indexOf(record),
        event
      })
    },
    // @Default
    onTableRequest: function () {
    },
    // @Default
    onPageChanged: function () {
    },
    // @Default
    onDeleteRow: function (row) {
      const index = this.rows.indexOf(row)
      if (index !== -1) {
        const propData = this.object[this.tabProp.key]
        for (const key in propData) {
          propData[key].splice(index, 1)
        }
      }
    },
    // @Default
    onEditRow: function (row) {
      // TO DO
      const index = this.rows.indexOf(row)
      if (index !== -1) {
        this.$emit('edit', { row, index })
      }
    },

    // @Default
    getTrStyle: function (row) {
    },
    // @Default
    isRowReadonly: function (row) {
    }
  }
}
